import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';
import { Constants } from '../constants/constants';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { SearchDataService } from '../service/search-data.service';
import { isNullOrUndefined } from 'util';
import { VehicleService } from '../service/vehicle.service';
import { MessageConstants } from '../constants/message-constants';
import { EnrollmentConstants } from '../constants/enrollment-constants';
import { EnvService } from '../service/env.service';

const PAGE_SIZE: number = 50;

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss']
})
export class VehiclesComponent implements OnInit {

  readonly CHOOSE_FILE: string = "Select File";

  vehicle: any = {};
  vehicleList: any = [];
  vehicleImportEntryTypes: any = ['QUICK_ENTRY', 'DETAILED_ENTRY'];
  selectedVehicleEntryType: string = "QUICK_ENTRY";
  vehicleQuickEntryFile: File = null;
  vehicleDetailedEntryFile: File = null;
  fleetVehicleEntry: File = null;
  accountType: string;
  fleetId: String = null;
  account: any = {};
  importFile: File = null;

  @ViewChild('addVehicleForm', { static: true }) public addVehicleForm: NgForm;
  invalidMake: boolean = false;
  selectedVehicle: any;
  isViewVehicleDetail: boolean = false;
  brands: any[] = ["NISSAN", "INFINITI"];
  minYear: number;
  maxYear: number;

  //Search result storage variable
  @ViewChild('searchResult') searchResult: SearchResultsComponent;
  searchedVehicleList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;
  isSearchResult: boolean = false;

  importFileName: string = this.CHOOSE_FILE;
  @ViewChild('vehiclesCompImportVehicleInput') vehiclesCompImportVehicleInput: ElementRef;
  @ViewChild('vehiclesCompRemoveVehiclesFromAccountInput', { static: true }) vehiclesCompRemoveVehiclesFromAccountInput: ElementRef;

  selectedVehicles: Array<any> = [];

  previousPage: number;
  currentPage: number;
  nextPage: number;

  //Filters
  // vehiclesMasterData = [];
  vehicleFilters: any = {};
  // selectedFilterOptions: Array<string> = ["all", "all", "all"];
  enrollmentEligibleFilterOptions: Array<boolean> = [true, false];
  /* enrollmentStatusFilterOptions: Array<string> = ["NOT_APPLICABLE", "NOT_ENROLLED", "ENROLLMENT_IN_PROGRESS", "ENROLLED", "ENROLLMENT_RETRY", "ENROLLMENT_FAILED", "UNENROLLMENT_IN_PROGRESS", 
    "UNENROLLED", "UNENROLLMENT_RETRY", "UNENROLLMENT_FAILED"]; */
  enrollmentStatusFilterOptions: Array<string> = [];
  vehicleStatusFilterOptions: Array<string> = ["ORDERED", "DELIVERED", "INACTIVE", "ASSIGNED", "PENDING", "ACTIVE", "DELETED"];
  certificatesFilterOptions: Array<string> = [];
  selectedCertificateFilterOption = null;
  enrollVehicles = EnrollmentConstants.ENROLL_NOW;
  unenrollVehicles = EnrollmentConstants.UNENROLL_NOW;
  vehicleServiceProviderType = Constants.VEHICLE_SERVICE_PROVIDER;

  reviewVehicleModalMessages = {
    header: "Delete Vehicle(s)",
    message: "Confirm deleting vehicles?",
    note: "Once defleeted, data on these VINs are remotely wiped and VINs would no longer be part of the fleet, and cannot be automatically added back to the account."
  }
  dongleStatusFilterOptions: Array<string> = ["NONE", "ATTACHED", "ENABLED", "LINKED", "UNLINKED"];

  yyyymmddDate = null;
  csvSampleFileName = null;
  mimeType = "csv";

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private toastService: ToastService, private searchService: SearchDataService,
    private vehicleService: VehicleService, private env: EnvService) {

  }


  ngOnInit() {
    this.enrollmentStatusFilterOptions = this.getEnrollmentStatusFilterOptions();
    this.yyyymmddDate = this.utilService.getYYYYMMDD(new Date());
    this.csvSampleFileName = "NCC_FleetVehicleEntry_" + this.yyyymmddDate + ".csv";

    this.account = this.utilService.selectedRentalFleetAccount;
    this.initFilters();
    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });
    this.minYear = 2010;
    //var date = new Date();
    this.maxYear = new Date().getFullYear() + 1;
    console.log("year range: ", this.minYear, "-", this.maxYear);
    this.getPaginatedAccountVehicles(0);
    this.getAccountCertificates();
  }

  initFilters() {
    this.vehicleFilters = {
      "enrollmentEligibility": null,
      "enrollmentReady": null,
      "enrollmentStatus": null,
      "ignitionType": null,
      "make": null,
      "model": null,
      "oemCustomerIds": [],
      "servicesActivated": null,
      "status": null,
      "tcuType": null,
      "telematicsAvailability": null,
      "trim": null,
      "year": null
    }

    // if (['DEALER', 'CORPORATE'].includes(this.account.category)) {
    if (this.isDongleDeviceSupported()) {
      this.vehicleFilters["dongleStatus"] = null;
    }
  }

  private processSearchResult() {
    this.searchedVehicleList = this.searchService.getSearchedDataForType(Constants.VEHICLES);
    if (this.searchedVehicleList && this.searchedVehicleList.length > 0) {
      this.showSearchResult = true;
      this.selectedSearchItemForView = null;
      this.closeVehicleDetailClicked(null);
    } else {
      this.showSearchResult = false;
    }
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  onSearchItemDetail(searchItem: string) {
    this.selectedSearchItemForView = searchItem;
  }

  uploadVehicleLogoClicked() {
    document.getElementById("uploadLogoInput").click();
  }

  uploadVehicleLogo(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);
      formData.append('folder', 'vehicle/' + this.account.id);

      console.log("Upload image name : ", file.name);

      this.utilService.showSpinner();
      this.apiService.uploadFleetLogo(formData).then((data) => {
        this.utilService.hideSpinner();
        console.log("Response is :: ", data);
        this.vehicle["logo"] = data.imageUrl;
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.uploadVehicleLogo(event);
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
          else this.toastService.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  }

  isMakeValid() {
    var found = false;
    if (this.vehicle.make) {
      for (var i = 0; i < this.brands.length; i++) {
        console.log("make:", this.vehicle.make, " brands:", this.brands);
        if (this.vehicle.make.toLowerCase() == this.brands[i].toLowerCase()) {
          this.invalidMake = false;
          found = true;
        }
      }
      if (!found) { this.invalidMake = true };
    }
  }

  onCreateVehicle(form: NgForm) {
    console.log("vehicle data::", this.vehicle);
    if (form.valid) {
      const requestPayload = {
        "type": "VEHICLE",
        "provisioningData": {
          "enterpriseId": this.authService.loggedInUser.enterpriseId,
          "accountId": this.account.id,
          "vin": this.vehicle.vin,
          "make": this.vehicle.make.toUpperCase(),
          "model": this.vehicle.model.toUpperCase(),
          "year": this.vehicle.year,
          "logo": this.vehicle.logo,
          "color": this.vehicle.color
        }
      }
      console.log("Adding vehicle with data : ", requestPayload);
      this.addAccountVehicle(requestPayload);

    }
  }

  addAccountVehicle(requestPayload: any) {
    this.utilService.showSpinner();
    this.apiService.addVehicle(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("add vehicle response ::", data);
      this.toastService.showSuccess(data.message);
      document.getElementById("closeAddVehicle").click();
      this.resetAddVehicleForm();
      this.getPaginatedAccountVehicles(0);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addAccountVehicle(requestPayload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getPaginatedAccountVehicles(page: number) {
    var requestPayload = this.getVehicleFilters();
    requestPayload = this.updateFilterForNmac(JSON.parse(JSON.stringify(requestPayload)));
    console.log("--- requestPayload: ", requestPayload);

    this.utilService.showSpinner();
    this.apiService.getPaginatedAccountVehicles(requestPayload, page, PAGE_SIZE).then((data) => {
      this.utilService.hideSpinner();
      console.log("vehicles response::", data);
      this.processVehicleResponse(data);
      this.invalidMake = false
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPaginatedAccountVehicles(page);
        });
      }
      else {
        this.utilService.hideSpinner();
        this.invalidMake = false
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getVehicleFilters() {
    if (this.vehicleFilters.enrollmentEligibility) {
      this.vehicleFilters.enrollmentReady = true;
    } else {
      this.vehicleFilters.enrollmentReady = null;
    }

    var filters = JSON.parse(JSON.stringify(this.vehicleFilters));
    if (filters.enrollmentStatus == "ENROLLED_FOR_DATA") {
      filters.enrollmentStatus = null;
      filters.enrolledForData = true;
    }

    return filters;
  }

  private processVehicleResponse(vehicleResponse: any) {
    this.vehicleList = vehicleResponse.vehicles;

    // shu: just for testing, delete immediately
    /* let statuses = ['ATTACHED', 'ENABLED', 'NONE', 'UNLINKED', 'DELETED', 'DISABLED', 'LINKED'];
    for (let i = 0; i < statuses.length; i++) {
      this.vehicleList[i].deviceStatus = statuses[i];
    } */

    this.setVariablesInVehicleList();
    console.log("vehicles ::", this.vehicleList);
    // this.vehiclesMasterData = this.vehicleList.map(x => Object.assign({}, x));
    this.nextPage = vehicleResponse.nextPage;
    this.currentPage = vehicleResponse.curPage;
    this.previousPage = vehicleResponse.prevPage;
  }

  setVariablesInVehicleList() {
    if (isNullOrUndefined(this.vehicleList) || this.vehicleList.length == 0) return;
    this.vehicleList.forEach(vehicle => {
      if (vehicle.enrollmentEligibility == false) {
        if (isNullOrUndefined(vehicle.enrollmentStatus) || vehicle.enrollmentStatus == '') {
          vehicle['enrollmentStatus'] = this.enrollmentStatusFilterOptions[0];
        }
      } else if (isNullOrUndefined(vehicle.enrollmentStatus) || vehicle.enrollmentStatus == '') {
        vehicle['enrollmentStatus'] = this.enrollmentStatusFilterOptions[1];
      } else if (vehicle['enrollmentStatus'] == "ENROLLMENT_RETRY") {
        vehicle['enrollmentStatus'] = this.enrollmentStatusFilterOptions[2];
      }
    });
  }

  vehicleSelected(vehicle) {
    if (vehicle.status != 'DELETED') {
      this.getVehicleDetail(vehicle.vin);
    } else {
      if (!vehicle.devices) {
        vehicle.devices = [];
      }
      this.selectedVehicle = vehicle;
      this.isViewVehicleDetail = true;
    }

    // this.selectedVehicle = JSON.parse(JSON.stringify(vehicle));
    //this.prepareSelectedVehicle();
    // document.getElementById("openViewServicePackage").click();
    // this.isViewVehicleDetail = true;
  }

  closeVehicleDetailClicked(data) {
    this.isViewVehicleDetail = false;
  }

  onVehicleEntryTypeSelected() {
    console.log("Vehicle Entry Upload Type::", this.selectedVehicleEntryType);
  }

  uploadVehicleEntries() {
    let formData: FormData = new FormData();
    /* if (this.selectedVehicleEntryType == this.vehicleImportEntryTypes[0])
      formData.append('file', this.vehicleQuickEntryFile, this.vehicleQuickEntryFile.name);
    if (this.selectedVehicleEntryType == this.vehicleImportEntryTypes[1])
      formData.append('file', this.vehicleDetailedEntryFile, this.vehicleDetailedEntryFile.name); */

    formData.append('file', this.fleetVehicleEntry, this.fleetVehicleEntry.name);
    this.uploadCsvFile(formData);
  }

  uploadCsvFile(formData: FormData) {
    this.utilService.showSpinner();
    this.apiService.uploadCsvFile(formData).then((data) => {
      this.utilService.hideSpinner();
      console.log("vehicle entry response :: ", data);
      this.toastService.showSuccess(data.message);
      document.getElementById("closeImportVehicle").click();
      document.getElementById("closeRemoveVehicle").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.uploadCsvFile(formData);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  /* onVehicleFileSelected(files: FileList) {
    this.vehicleQuickEntryFile = null;
    this.vehicleDetailedEntryFile = null;
    // https://www.youtube.com/watch?v=YkvqLNcJz3Y
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      this.updateFileName(file);
      if (this.isCsvFile(file.name) && this.isValidVehicleEntryFile(file.name)) {
        if (this.selectedVehicleEntryType == this.vehicleImportEntryTypes[0]) {
          this.vehicleQuickEntryFile = file;
        }
        if (this.selectedVehicleEntryType == this.vehicleImportEntryTypes[1]) {
          this.vehicleDetailedEntryFile = file;
        }
      } else {
        this.resetVehicleImport();
      }
    } else {
      this.resetVehicleImport();
    }
  } */
  onVehicleFileSelected(files: FileList) {
    this.fleetVehicleEntry = null;
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      this.updateFileName(file);
      if (this.isCsvFile(file.name) && this.isValidVehicleEntryFile(file.name)) {
        this.fleetVehicleEntry = file;
      } else {
        this.resetVehicleImport();
      }
    } else {
      this.resetVehicleImport();
    }
  }

  updateFileName(file: File) {
    var fileName = file.name;
    // if(fileName && fileName.length > 35) {
    //   fileName = fileName.substring(0,35) + '...';
    // }
    this.importFileName = fileName;
  }

  isFileSelected(files: FileList) {
    if (files && files.length > 0)
      return true;
    return false;
  }

  isCsvFile(name: string) {
    let splitStr = name.split('.');
    let extension = splitStr[splitStr.length - 1];
    if (extension.toLowerCase() != 'csv') {
      this.toastService.showError("Please select .csv file only");
      return false;
    }
    return true;
  }

  isValidVehicleEntryFile(name: string) {
    let splitStr = name.split('_');

    /***** VehicleQuickEntry and VehicleDetailedEntry code below *****/
    if (splitStr.length < 3) {
      this.toastService.showError("Invalid file name format. Expected file name format: NCC_FleetVehicleEntry_05132019101630.csv");
      return false;
    }
    let importType = splitStr[1];
    if (importType != "FleetVehicleEntry") {

      this.toastService.showError("Invalid file name format. Expected file name format: NCC_FleetVehicleEntry_05132019101630.csv");
      return false;
    }

    /***** VehicleQuickEntry and VehicleDetailedEntry code below *****/
    // if (splitStr.length < 4) {
    //   if (this.selectedVehicleEntryType == this.vehicleImportEntryTypes[0])
    //     this.toastService.showError("Invalid file name format. Expected file name format: NCC_VehicleQuickEntry_" + this.account.id + "_05132019101630.csv");
    //   if (this.selectedVehicleEntryType == this.vehicleImportEntryTypes[1])
    //     this.toastService.showError("Invalid file name format. Expected file name format: NCC_VehicleDetailedEntry_" + this.account.id + "_05132019101630.csv");
    //   return false;
    // }
    // importType = splitStr[1];
    // let accountId = splitStr[2];
    // if (importType != "VehicleQuickEntry" && importType != "VehicleDetailedEntry") {
    //   if (this.selectedVehicleEntryType == this.vehicleImportEntryTypes[0])
    //     this.toastService.showError("Invalid file name format. Expected file name format: NCC_VehicleQuickEntry_" + this.account.id + "_05132019101630.csv");
    //   if (this.selectedVehicleEntryType == this.vehicleImportEntryTypes[1])
    //     this.toastService.showError("Invalid file name format. Expected file name format: NCC_VehicleDetailedEntry_" + this.account.id + "_05132019101630.csv");
    //   return false;
    // }
    // if (accountId != this.account.id) {
    //   this.toastService.showError("AccountId in filename mismatch with fleet accountId.");
    //   return false;
    // }
    return true;
  }

  onFileSelected(files: FileList, type: string) {
    this.importFile = null;
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      this.updateFileName(file);
      if (this.isCsvFile(file.name) && this.isValidFileName(file.name, type)) {
        this.importFile = file;
      } else {
        this.resetRemoveVehicleImport();
      }
    } else {
      this.resetRemoveVehicleImport();
    }
  }

  uploadFile() {
    let formData: FormData = new FormData();
    formData.append('file', this.importFile, this.importFile.name);
    this.uploadCsvFile(formData);
  }

  isValidFileName(name: string, type: string) {
    let splitStr = name.split('_');
    if (splitStr.length < 4) {
      this.toastService.showError("Invalid file name format. Expected file name format: NCC_" + type + "_" + this.account.id + "_05132019101630.csv");
      return false;
    }
    let importType = splitStr[1];
    let accountId = splitStr[2];
    if (importType != type) {
      this.toastService.showError("Invalid file name format. Expected file name format: NCC_" + type + "_" + this.account.id + "_05132019101630.csv");
      return false;
    }
    if (accountId != this.account.id) {
      this.toastService.showError("The accountId in the filename doesn't match the selected fleet's accountId.");
      return false;
    }
    return true;
  }

  resetAddVehicleForm() {
    this.addVehicleForm.resetForm();
    this.vehicle = {};
  }

  onVehicleImportClose() {
    this.selectedVehicleEntryType = this.vehicleImportEntryTypes[0];
    this.resetVehicleImport();
  }

  resetVehicleImport() {
    this.vehiclesCompImportVehicleInput.nativeElement.value = null;
    this.importFileName = this.CHOOSE_FILE;
    this.vehicleQuickEntryFile = null;
    this.vehicleDetailedEntryFile = null;
    this.fleetVehicleEntry = null;
  }

  resetRemoveVehicleImport() {
    this.vehiclesCompRemoveVehiclesFromAccountInput.nativeElement.value = null;
    this.importFileName = this.CHOOSE_FILE;
    this.importFile = null;
  }

  getPreviousPage() {
    this.getPaginatedAccountVehicles(this.previousPage);
  }

  getNextPage() {
    this.getPaginatedAccountVehicles(this.nextPage);
  }

  onVehicleSelectionChange(checked: boolean, vehicle: any) {
    var vehicleIndex = this.selectedVehicles.findIndex(v => v.vin === vehicle.vin);

    if (checked && vehicleIndex == -1) {
      this.selectedVehicles.push(vehicle);
    } else if (!checked && vehicleIndex >= 0) {
      this.selectedVehicles.splice(vehicleIndex, 1);
    }
  }

  onDeleteVehicles() {
    console.log("selected vehicles::", this.selectedVehicles);
    document.getElementById("openReviewVehicles").click();
  }

  resetSelectedVehicles() {
    this.selectedVehicles = [];
    this.resetCheckbox();
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }

  getAccountCertificates() {
    this.utilService.showSpinner();
    this.apiService.getCertificates().then((certificates) => {
      this.utilService.hideSpinner();
      console.log("certificate list : ", certificates);
      if (certificates != null && certificates.length > 0) {
        this.certificatesFilterOptions = certificates.map(function (certificate) {
          return certificate['oemCustomerId'];
        });
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountCertificates();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onCertificateChange() {
    this.vehicleFilters.oemCustomerIds = this.selectedCertificateFilterOption == null ? [] : [this.selectedCertificateFilterOption];
    this.getPaginatedAccountVehicles(0);
  }

  isVehicleSelected(vehicle: string): boolean {
    if (isNullOrUndefined(this.selectedVehicles) || this.selectedVehicles.length == 0) return false;
    return this.selectedVehicles.some(v => v.vin === vehicle);
  }

  reviewVehiclesSubmit(vehicles) {
    this.selectedVehicles = vehicles;
    this.defleetVehicles();
  }

  getVehicleLogo(vehicle): string {
    return this.vehicleService.getVehicleLogo(vehicle);
  }

  defleetVehicles() {
    var requestPayload = this.getDefleetVehiclesPayload();
    this.utilService.showSpinner();
    this.apiService.defleetVehicles(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("Defleet vehicle(s) initiated: ", data);
      this.toastService.showSuccess(MessageConstants.DEFLEET_VEHICLES_INITIATED);
      document.getElementById("closeReviewVehicles").click();
      this.resetSelectedVehicles();
      this.getPaginatedAccountVehicles(0);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.defleetVehicles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getDefleetVehiclesPayload() {
    let vehicles = this.selectedVehicles.map((vehicle) => vehicle.vin);
    return {
      "vehicles": vehicles
    }
  }

  refreshVehicleList() {
    this.getPaginatedAccountVehicles(this.currentPage);
  }

  getVehicleDetail(vin) {
    this.utilService.showSpinner();
    this.apiService.getVehicleDetails(vin).then((data) => {
      this.utilService.hideSpinner();
      console.log("Get vehicle detail from api : ", data);

      /* data.devices.push({
        "type": "DONGLE_DEVICE",
        "id": "6475b0cfa71f54d2280788dd",
        "deviceStatus": "INACTIVE",
        "telematicsType": "AFTER_MARKET",
        "telematicsProvider": "CONTINENTAL",
        "accountId": "623189b507d14f7020c27cae",
        "deviceSerialNumber": "ACCMb789680e0768ec8e",
        "dongleStatus": "ENABLED"
      }); */

      this.selectedVehicle = data;
      this.isViewVehicleDetail = true;

    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehicleDetail(vin);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  // NATODO: Copy this in vehicle list and change in html
  isDongleDeviceSupported() {
    if (this.utilService.doesAccountSupportsDongle(this.account.category)) {
      return true;
    }
    return false;
  }

  downloadSampleCsv() {
    console.log("attachment mime type::", this.mimeType);
    this.utilService.showSpinner();
    var attachmentUrl = this.env.BASE_URL + Constants.IMPORT_VEHICLE_SAMPLE_CSV_URL;

    this.apiService.downloadPdf(attachmentUrl).then((data) => {
      this.prepareToDownload(data, this.mimeType, this.csvSampleFileName);
      this.utilService.hideSpinner();
    }).catch((error) => {
      console.log("err : ", error);
      if (error && error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.downloadSampleCsv();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareToDownload(data, mimeType, filename: string) {
    var blob = new Blob([data], { type: mimeType });

    var downloadURL = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = downloadURL;
    link.download = filename;
    link.click();
  }

  getVehicleEnrollmentStatus(vehicle: any): string {
    //For testing.
    // vehicle.enrolledForData = false;
    // vehicle.enrollmentStatus = Constants.UNENROLLMENT_CANCELED;

    return this.utilService.getVehicleEnrollmentStatus(vehicle);
  }

  updateFilterForNmac(payload) {
    if (this.utilService.isNmacAccount(this.authService.loggedInUser.accountId)) {
      if (payload.enrollmentStatus == "NOT_APPLICABLE") {
        payload.enrollmentStatus = "ENROLLED";
      } else if (payload.enrollmentStatus == "ENROLLED") {
        payload.enrollmentStatus = "NOT_APPLICABLE";
      }
    }
    return payload;
  }

  getEnrollmentStatusFilterOptions() {
    if (this.utilService.isNmacAccount(this.authService.loggedInUser.accountId))
      return ["NOT_APPLICABLE", "NOT_ENROLLED", "ENROLLMENT_IN_PROGRESS", "ENROLLED"];
    return ["NOT_APPLICABLE", "NOT_ENROLLED", "ENROLLMENT_IN_PROGRESS|ENROLLMENT_RETRY|ENROLLMENT_INITIATED", "ENROLLED", "ENROLLMENT_FAILED", "UNENROLLMENT_IN_PROGRESS|UNENROLLMENT_RETRY|UNENROLLMENT_INITIATED",
      "UNENROLLED", "UNENROLLMENT_FAILED", "ENROLLED_FOR_DATA"];
  }
}
